import TrackingPagesList from './TrackingPagesList';
import TrackingPagesListItem from './TrackingPagesListItem';

export default TrackingPagesList;
export { TrackingPagesListItem };
